import React from "react";
import { Mail, Phone, Globe } from "lucide-react";

export default function About() {
  return (
    <section
      id="story"
      data-testid="story-section"
      className="relative bg-[#F4F1EA] py-24 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <div className="lg:col-span-5 relative">
          <div className="absolute -top-6 -left-4 font-display text-[8rem] leading-none text-[#D96C2B]/20 select-none pointer-events-none">
            “
          </div>
          <img
            src="https://customer-assets.emergentagent.com/job_thai-tasty-treats/artifacts/q116exav_Cup%20of%20Thai%20Tea.jpg"
            alt="Cup of Thai iced tea"
            className="relative w-full h-[420px] lg:h-[520px] object-cover shadow-[0_30px_60px_-20px_rgba(31,41,36,0.35)]"
          />
        </div>

        <div className="lg:col-span-7 lg:pl-10">
          <div className="text-xs uppercase tracking-[0.3em] text-[#D96C2B] mb-6">
            Meet P. Nong
          </div>
          <h2 className="font-display text-[#2C4C3B] text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-tight">
            A family recipe,
            <span className="italic"> bottled with love.</span>
          </h2>
          <div className="mt-8 space-y-6 text-[#4A5D53] text-lg leading-relaxed max-w-xl">
            <p>
              Thai Tasty Treats started in a small Florida kitchen, where
              P. Nong began brewing the same iced tea her grandmother used to
              serve in Thailand — strong, fragrant, finished with a slow
              curl of sweetened cream.
            </p>
            <p>
              What started as a treat for friends and neighbors grew into
              three bottled classics. Every batch is brewed by hand, in small
              numbers, so the flavor always tastes like home.
            </p>
          </div>

          <div
            id="contact"
            className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-xl"
            data-testid="contact-block"
          >
            <a
              href="mailto:P.Nong@ThaiTastyTreats.com"
              className="group flex items-start gap-3 text-[#2C4C3B] hover:text-[#D96C2B] transition-colors"
              data-testid="contact-email"
            >
              <Mail className="h-5 w-5 mt-1 flex-shrink-0" />
              <div className="text-sm">
                <div className="uppercase tracking-widest text-[10px] text-[#4A5D53] mb-1">
                  Email
                </div>
                <div className="break-all">P.Nong@ThaiTastyTreats.com</div>
              </div>
            </a>
            <a
              href="tel:3525524074"
              className="group flex items-start gap-3 text-[#2C4C3B] hover:text-[#D96C2B] transition-colors"
              data-testid="contact-phone"
            >
              <Phone className="h-5 w-5 mt-1 flex-shrink-0" />
              <div className="text-sm">
                <div className="uppercase tracking-widest text-[10px] text-[#4A5D53] mb-1">
                  Phone
                </div>
                <div>352-552-4074</div>
              </div>
            </a>
            <div className="flex items-start gap-3 text-[#2C4C3B]" data-testid="contact-web">
              <Globe className="h-5 w-5 mt-1 flex-shrink-0" />
              <div className="text-sm">
                <div className="uppercase tracking-widest text-[10px] text-[#4A5D53] mb-1">
                  Online
                </div>
                <div>ThaiTastyTreats.com</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
